import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Button, CircularProgress } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import api from '../../../utils/api';

function CarpoolingPassenger({
  userId,
  tenant,
  rental,
  currentPassengers,
  handleChoisePassenger,
  driverCanAddPassengers
}) {
  const { t } = useTranslation(['booking', 'common', 'search']);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMatchingUsers = async () => {
      if (inputValue.length < 4) return;

      setLoading(true);
      try {
        const { users } = await api.user.search({ inputValue });
        setOptions(users);
      } catch (err) {
        console.error('Erreur API:', err);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    const debounce = setTimeout(() => {
      fetchMatchingUsers();
    }, 500);

    return () => clearTimeout(debounce);
  }, [inputValue]);

  if (!tenant.useCarpooling || !rental.carpooling) return null;

  const handleChoise = (event, newValue) => {
    if (!newValue || newValue === '') return [];
    setSelectedOption(newValue);
  };

  const onClickHandleChoisePassenger = () => {
    if (typeof handleChoisePassenger === 'function') {
      handleChoisePassenger(selectedOption);
      setSelectedOption('');
    }
  };

  return (
    <div className="section">
      <div className="title">{t('booking:passengers')}</div>
      <div className="section-content">
        {currentPassengers.map((passenger, i) => (
          <p key={i}>
            {passenger.first_name} {passenger.last_name}
          </p>
        ))}
      </div>

      {driverCanAddPassengers && rental.driver_id === userId && (
        <div>
          <Autocomplete
            options={options}
            getOptionLabel={option => option.email}
            value={selectedOption}
            onChange={handleChoise}
            noOptionsText={t('booking:not-found-passengers')}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) =>
              setInputValue(newInputValue)
            }
            loading={loading}
            renderInput={params => (
              <TextField
                {...params}
                label="Email"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }}
              />
            )}
          />

          <Button
            className="booking-actions"
            variant="contained"
            color="primary"
            size="small"
            onClick={onClickHandleChoisePassenger}
            style={{ marginTop: 8 }}
          >
            {t('booking:add-passenger')}
          </Button>
        </div>
      )}
    </div>
  );
}

export default CarpoolingPassenger;
